import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!

  return (_openBlock(), _createBlock(_component_a_steps, {
    space: 200,
    current: _ctx.active,
    "finish-status": "success"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsTitle, (item) => {
        return (_openBlock(), _createBlock(_component_a_step, {
          title: item,
          key: item
        }, null, 8, ["title"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["current"]))
}